import { getLocalStore, setLocalStore } from '../util/Helpers';

import config from './../config.json'

export const DEMO_MODE = 'demo'

const oauthConfig = config['oauth'] || {}

export const conf = {
    "env": config['env'],
    "token": config['demo']['token'],
    "endpoint": config['api']['endpoint'],
    "oauth": {
        "clientId": process.env.REACT_APP_KI_OAUTH_CLIENT_ID || oauthConfig['clientId'] || '',
        "clientSecret": process.env.REACT_APP_KI_OAUTH_CLIENT_SECRET || oauthConfig['clientSecret'] || ''
    }
}

const Config = () => {

    const setMode = () => {
        const getMode = getLocalStore(DEMO_MODE)
        if(!getMode)
        {
            setLocalStore(DEMO_MODE, config['demo']['status'])
        }
    }

    if(conf['env']!=='production'||conf['env']!=='staging')
    {
        setMode()
    }

}

export default Config;
